import { useState } from "react";
import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import Loading from "../../../../common/components/ui/loading/Loading";
import { addRepossessionNote } from "../../../../common/services/repossession.api";
import { IRepossession } from "../../../../types/repossession.type";

type Props = {
  repossession: IRepossession;
  onClose: () => void;
  onSuccess: () => void;
};

export default function ModalAddNote(props: Props) {
  const { repossession, onClose, onSuccess } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [noteText, setNoteText] = useState("");
  const { notifyError } = useToastContext();

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!noteText.trim()) {
      notifyError("A observação não pode estar vazia.");
      return;
    }
    setIsLoading(true);
    try {
      const response = await addRepossessionNote(
        repossession._id as string,
        noteText
      );

      if (response.ok) {
        onSuccess();
      } else {
        notifyError(response.message || "Erro ao adicionar observação.");
      }
    } catch (err) {
      console.error(err);
      notifyError("Ocorreu um erro inesperado. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Modal size={"3xl"} className="relative" show={true} onClose={onClose}>
      <Modal.Header className="text-black">
        <div className="flex items-center justify-start gap-3 text-black">
          <span>{`Adicionar Observação - ${repossession.vehicle.licensePlate}`}</span>
        </div>
      </Modal.Header>
      <Modal.Body className="w-full relative border-gray flex flex-col text-black">
        {isLoading && <Loading />}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="noteText"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Observação
            </label>
            <textarea
              id="noteText"
              name="noteText"
              rows={6}
              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              value={noteText}
              onChange={(e) => setNoteText(e.target.value)}
              placeholder="Digite sua observação aqui..."
              required
              disabled={isLoading}
            />
          </div>
          <div className="flex justify-end gap-4 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300"
              disabled={isLoading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:opacity-50"
              disabled={isLoading}
            >
              {isLoading ? "Salvando..." : "Salvar"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
